import { Injectable } from '@angular/core';
import { GuidWrapper } from '../types';
import { Guid } from 'guid-typescript';
import { IImageElement } from '../interfaces';
import { DEFAULT_IMAGE_DATA, DEFAULT_IMAGE_LAYER } from '../constants';
import { CreatorStateService } from '../services/app-services';
import { ShapeAttributesManager } from './shape-attributes.manager';
import { ShapeKeys } from '../enums';

@Injectable()
export class ImageManager {

  public static getDataToSend(img: Partial<GuidWrapper<IImageElement>>): IImageElement {
    return {
      id: img.id ?? DEFAULT_IMAGE_DATA.id,
      imageId: img.imageId ?? DEFAULT_IMAGE_DATA.imageId,
      x: img.x ?? DEFAULT_IMAGE_DATA.x,
      y: img.y ?? DEFAULT_IMAGE_DATA.y,
      w: img.w ?? DEFAULT_IMAGE_DATA.w,
      h: img.h ?? DEFAULT_IMAGE_DATA.h,
      layer: img.layer ? (img.layer - DEFAULT_IMAGE_LAYER) : DEFAULT_IMAGE_DATA.layer,
      lock: img.lock ?? DEFAULT_IMAGE_DATA.lock
    };
  }

  public static formatObject(img: Partial<GuidWrapper<IImageElement>>): GuidWrapper<IImageElement> {
    return {
      guid: img.guid ?? Guid.raw(),
      id: img.id ?? DEFAULT_IMAGE_DATA.id,
      imageId: img.imageId ?? DEFAULT_IMAGE_DATA.imageId,
      x: img.x ?? DEFAULT_IMAGE_DATA.x,
      y: img.y ?? DEFAULT_IMAGE_DATA.y,
      w: img.w ?? DEFAULT_IMAGE_DATA.w,
      h: img.h ?? DEFAULT_IMAGE_DATA.h,
      layer: img.layer ?? DEFAULT_IMAGE_DATA.layer,
      lock: img.lock ?? DEFAULT_IMAGE_DATA.lock
    };
  }

  public static getHTMLElement(guid: string, container?: HTMLElement): HTMLElement {
    return (container ?? CreatorStateService.roomRef.nativeElement).querySelector<HTMLElement>(
      `[${ShapeAttributesManager.getAttribute(ShapeKeys.GUID)}="${guid}"]`
    ) || null;
  }

  public static getImageElement(guid: string): GuidWrapper<IImageElement> {
    return CreatorStateService.seatsPlan.images.find(x => x.guid === guid);
  }

  public static transformHTMLElementToObject(el: HTMLElement): GuidWrapper<IImageElement> {
    const image = CreatorStateService.seatsPlan.images.find((img) => img.guid === ShapeAttributesManager.getGUID(el));

    const elData = {
      x: parseInt(el.style.left),
      y: parseInt(el.style.top),
      w: el.style.width ? parseInt(el.style.width) : 30,
      h: el.style.height ? parseInt(el.style.height) : 30,
      guid: ShapeAttributesManager.getGUID(el),
      imageId: image?.imageId ?? null,
      lock: image?.lock ?? false,
      id: image?.id ?? null,
      layer: image?.layer ?? 0
    } as GuidWrapper<IImageElement>;

    return ImageManager.formatObject(elData);
  }
}
